import React from 'react';

import { Datos as AlumnosDatos } from '../../S3Alumnos';

const AREAS = {
    preu: 'Preu',
    ingles: 'Inglés',
    aleman: 'Alemán',
    japones: 'Japonés',
};

const IdentificacionContrato = ({
    alumno,
    numero,
}: {
    alumno: AlumnosDatos['alumnoPrincipal'];
    numero: number;
}) => {
    const nombre = `${alumno.personales.primerNombre} ${alumno.personales.apellidoPaterno}`;
    const area = AREAS[alumno.matricula.area];

    return (
        <>
            Contrato {numero} ({nombre}) <span style={{ color: 'gray' }}> &mdash; {area}</span>
        </>
    );
};

export default IdentificacionContrato;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/S4Financieros/componentes/IdentificacionContrato.tsx